var l={loyaltyPoint:null};export{l as default};
